import api, { handleAPIErrors} from 'shared/api'

const FETCH_REQUEST = 'superannuationClassification/FETCH_REQUEST'
const FETCH_SUCCESS = 'superannuationClassification/FETCH_SUCCESS'
const FETCH_FAILURE = 'superannuationClassification/FETCH_FAILURE'

const initialState = {
  result: [],
  loaded: false,
  loading: false,
  errors: []
}

export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload: payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    loaded: false,
    loading: false,
    errors,
  }
}

export function loadSuperannuationClassifications() {
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api(`api/v1/superannuation_classifications`, {}, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }
        dispatch(fetchSuccess(json))
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: payload
      })
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: {
          ...state.result,
          errors: payload.errors
        }
      }
    default:
      return state
  }
}
